import React from 'react'
import _ from 'lodash/fp'

const PRIMARY_EVIDENCE = ({extension}) => extension.toLowerCase() === "mrxs"

const WHITE_LIST = ['mrxs','dat','ini']

const FILTER_GROUP = (primaryFile,compatible) => {
  const miraxRoot = primaryFile.path + "/" + primaryFile.filename
  return compatible.path === miraxRoot
}

const VALIDATE = (group) => {
  const slideDat = group.find(({file}) => file.name.toLowerCase() === 'slidedat.ini')
  const dat = group.filter(({extension}) => extension.toLowerCase() === 'dat')
  return slideDat && dat.length>0
}


export const MiraxParserConfig = {PRIMARY_EVIDENCE,WHITE_LIST,FILTER_GROUP,VALIDATE}